export default __webpack_public_path__ + "static/media/TamarabadgeEN.27f35944.svg";